// extracted by css-extract-rspack-plugin
export default {"listViewColumnItem":"um2pL"};